import React, { useEffect, useRef, useState } from 'react'
import { Wrapper } from '../style'
import { Table, Modal, Input, Select } from 'antd';
import { MakeApiCall } from "../../../../../apis";

const { Option } = Select;

function SpApi({ loading, list, userData }) {
    const applicationId = 'amzn1.sp.solution.0627cb04-5be2-42e5-bf08-c0bd6cae2b8f';
    const version = 'beta';
    const redirect_uri = 'https://app.sellerview.ai/settings/marketplace-credentials?tab=spApi';
    const hasCalledApi = useRef(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sellerName, setSellerName] = useState(localStorage.getItem("spapi_sellerName") || "");
    const [selectedRegion, setSelectedRegion] = useState(localStorage.getItem("spapi_region") || "");
    const [selectedMarketplace, setSelectedMarketplace] = useState(localStorage.getItem("spapi_marketplace") || "");

    const allMarketplaces = [
        // North America
        { id: "ATVPDKIKX0DER", name: "Amazon.com", sales_channel: "US", region_name: "NA" },
        { id: "A2EUQ1WTGCTBG2", name: "Amazon.ca", sales_channel: "Canada", region_name: "NA" },
        { id: "A1AM78C64UM0Y8", name: "Amazon.com.mx", sales_channel: "Mexico", region_name: "NA" },
        { id: "A2Q3Y263D00KWC", name: "Amazon.com.br", sales_channel: "Brazil", region_name: "NA" },

        // Europe
        { id: "A1PA6795UKMFR9", name: "Amazon.de", sales_channel: "Germany", region_name: "EU" },
        { id: "A1RKKUPIHCS9HS", name: "Amazon.es", sales_channel: "Spain", region_name: "EU" },
        { id: "A13V1IB3VIYZZH", name: "Amazon.fr", sales_channel: "France", region_name: "EU" },
        { id: "A1F83G8C2ARO7P", name: "Amazon.co.uk", sales_channel: "UK", region_name: "EU" },
        { id: "APJ6JRA9NG5V4", name: "Amazon.it", sales_channel: "Italy", region_name: "EU" },
        { id: "A1805IZSGTT6HS", name: "Amazon.nl", sales_channel: "Netherlands", region_name: "EU" },
        { id: "A2NODRKZP88ZB9", name: "Amazon.se", sales_channel: "Sweden", region_name: "EU" },
        { id: "A1C3SOZRARQ6R3", name: "Amazon.pl", sales_channel: "Poland", region_name: "EU" },
        { id: "A17E79C6D8DWNP", name: "Amazon.be", sales_channel: "Belgium", region_name: "EU" },

        // Asia-Pacific
        { id: "A21TJRUUN4KGV", name: "Amazon.in", sales_channel: "India", region_name: "FE" },
        { id: "A19VAU5U5O7RUS", name: "Amazon.sg", sales_channel: "Singapore", region_name: "FE" },
        { id: "A39IBJ37TRP1C6", name: "Amazon.au", sales_channel: "Australia", region_name: "FE" },
        { id: "A1VC38T7YXB528", name: "Amazon.co.jp", sales_channel: "Japan", region_name: "FE" },

        // Middle East
        { id: "A2VIGQ35RCS4UG", name: "Amazon.ae", sales_channel: "UAE", region_name: "FE" },
        { id: "A33AVAJ2PDY3EV", name: "Amazon.sa", sales_channel: "Saudi Arabia", region_name: "FE" },
        { id: "A17E79C6D8DWNP", name: "Amazon.eg", sales_channel: "Egypt", region_name: "FE" },
    ];

    // Open modal
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // Handle login
    const handleAmazonLogin = () => {
        // Save values in localStorage before redirect
        localStorage.setItem("spapi_sellerName", sellerName);
        localStorage.setItem("spapi_region", selectedRegion);
        localStorage.setItem("spapi_marketplace", selectedMarketplace);

        const state = `${userData?.user?.user_data?.id}!!${selectedRegion}!!${selectedMarketplace}`;
        const baseUrl = 'https://sellercentral.amazon.in/apps/authorize/consent';
        const params = new URLSearchParams({
            application_id: applicationId,
            version,
            state,
            redirect_uri
        });
        window.location.href = `${baseUrl}?${params.toString()}`; // same window redirect
    };

    useEffect(() => {
        const handleCallback = async () => {
            const url = new URL(window.location.href);
            const spapi_oauth_code = url.searchParams.get('spapi_oauth_code');
            const amazon_state = url.searchParams.get('state');
            const selling_partner_id = url.searchParams.get('selling_partner_id');

            if (!spapi_oauth_code || !selling_partner_id || !amazon_state) {
                return;
            }

            if (!hasCalledApi.current) {
                hasCalledApi.current = true;

                const parts = amazon_state.split('!!');
                const marketplace_id = parts[2] || null;

                const savedSellerName = localStorage.getItem("spapi_sellerName") || "Unknown Seller";

                console.log('OAuth Code:', spapi_oauth_code);
                console.log('Selling Partner ID:', selling_partner_id);
                console.log('Marketplace ID:', marketplace_id);
                console.log('Saved Seller Name:', savedSellerName);

                try {
                    const response = await MakeApiCall(
                        `sp-credentials/callback-url`,
                        'post',
                        {
                            spapi_oauth_code,
                            selling_partner_id,
                            marketplace_id,
                            seller_name: savedSellerName
                        },
                        true,
                        {},
                        userData?.token
                    );
                    console.log("API Success:", response);

                    if (window.history.replaceState) {
                        const cleanUrl = window.location.origin + window.location.pathname;
                        window.history.replaceState({}, document.title, cleanUrl);
                    }

                    localStorage.removeItem("spapi_sellerName");
                    localStorage.removeItem("spapi_region");
                    localStorage.removeItem("spapi_marketplace");

                    window.location.reload();
                } catch (err) {
                    console.error("Error in API call:", err);
                }
            }
        };

        handleCallback();
    }, [userData?.token]);

    const columns = [
        { title: 'Credential Type', dataIndex: 'credential_type', key: 'credential_type' },
        { title: 'Seller Name', dataIndex: 'seller_name', key: 'seller_name' },
        { title: 'Region', dataIndex: 'region', key: 'region' },
        { title: 'Marketplace', dataIndex: 'marketplace', key: 'marketplace' },
        { title: 'Marketplace ID', dataIndex: 'marketplace_id', key: 'marketplace_id' },
    ];

    return (
        <Wrapper>
            <div className="row gy-5 g-xl-5">
                <div className="col-xxl-12">
                    <div className="card card-xxl-stretch mb-5 mb-xl-8">
                        <div className="card-header border-bottom-dashed">
                            <h3 className="card-title fw-bolder">Amazon SP API Credentials List</h3>
                            <div className="card-toolbar">
                                {(!list || list.length === 0) && (
                                    <button className="btn btn-light-google" onClick={openModal}>
                                        Login With Amazon
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="card-body py-2">
                            <div className="table-responsive">
                                <Table
                                    scroll={{ x: 'max-content' }}
                                    columns={columns}
                                    loading={loading}
                                    dataSource={list}
                                    rowKey="key"
                                    pagination={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal for seller name + region + marketplace */}
            <Modal
                title="Amazon Login Details"
                open={isModalOpen}
                onCancel={closeModal}
                onOk={handleAmazonLogin}
                okText="Continue"
                okButtonProps={{
                    disabled: !sellerName.trim() || !selectedRegion || !selectedMarketplace,
                }}
            >
                <div className="mb-3">
                    <label>Seller Name</label>
                    <Input
                        value={sellerName}
                        onChange={(e) => setSellerName(e.target.value)}
                        placeholder="Enter Seller Name"
                    />
                </div>

                <div className="mb-3">
                    <label>Region</label>
                    <Select
                        style={{ width: "100%" }}
                        value={selectedRegion}
                        onChange={(value) => setSelectedRegion(value)}
                        placeholder="Select Region"
                    >
                        {[...new Set(allMarketplaces.map(m => m.region_name))].map(region => (
                            <Option key={region} value={region}>{region}</Option>
                        ))}
                    </Select>
                </div>

                <div className="mb-3">
                    <label>Marketplace</label>
                    <Select
                        style={{ width: "100%" }}
                        value={selectedMarketplace}
                        onChange={(value) => setSelectedMarketplace(value)}
                        disabled={!selectedRegion}
                        placeholder="Select Marketplace"
                    >
                        {allMarketplaces
                            .filter(m => m.region_name === selectedRegion)
                            .map(m => (
                                <Option key={m.id} value={m.id}>{m.name} ({m.sales_channel})</Option>
                            ))}
                    </Select>
                </div>
            </Modal>
        </Wrapper>
    )
}

export default SpApi;